import * as R from 'ramda';
import { useLayoutEffect, useState } from 'react';
import { Card } from './style';

const MAX_DESCRIPTION_LENGTH = 125;
const MAX_IMAGE_HEIGHT = 700;

const parseDescription = description => {
  if (!description) return '';
  if (description.length <= MAX_DESCRIPTION_LENGTH) return description;
  return `${description.substring(0, MAX_DESCRIPTION_LENGTH - 1)}...`;
}

const parseSource = source => {
  const splitSource = source.split('ipfs://');
  const sourceAddress = splitSource[1];
  return `${process.env.REACT_APP_IPFS_ENDPOINT}/${sourceAddress}`;
}

const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

const Parallax = ({ title, description, src }) => {
  const [show, setShow] = useState(true);
  const [imageSrc, setImageSrc] = useState(src);
  const [height, setHeight] = useState(`${random(400, MAX_IMAGE_HEIGHT)}px`);

  useLayoutEffect(() => {
    if (src && src.includes('ipfs://')) {
      const parsedSource = parseSource(src);
      return setImageSrc(parsedSource);
    }
  }, []);

  if (R.isEmpty(title) || R.isNil(title) || R.isNil(src)) return <></>;

  return show && <Card height={height}>
    <img src={imageSrc} srcSet={imageSrc} alt={title} onError={({ currentTarget }) => {
      currentTarget.style.display = "none";
      setShow(false);
    }} onLoad={({ target }) => {
      if (target.naturalHeight <= MAX_IMAGE_HEIGHT)
        setHeight(`${target.naturalHeight}px`);
    }} />
    <div className="info">
      <h1>{title}</h1>
      <p>{parseDescription(description)}</p>
    </div>
  </Card>
}

export default Parallax;